@if (!outline) {
  <button
    mat-icon-button
    (click)="trigger($event)"
    [class.animate]="animate"
    class="heart-button solid"
    >
    <mat-icon fontSet="material-icons">
      {{ active ? "favorite" : "favorite_border" }}
    </mat-icon>
  </button>
}

@if (outline) {
  <button
    (click)="trigger($event)"
    [class.animate]="animate"
    class="heart-button outline"
    mat-icon-button
    >
    <mat-icon fontSet="material-icons">
      {{ active ? "favorite" : "favorite_border" }}
    </mat-icon>
  </button>
}
